export function initRegistration() {
    $('label[for="koncovy-zakaznik"]').html('<strong>Kundentyp Endkunde</strong>');
    $('label[for="velkoobchodni-odberatel"]').html('<strong>Großhandelskunde</strong> &nbsp;(Die Registrierung wird in Kürze geprüft und freigeschaltet)');
}